import { CircularProgress, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@material-ui/core'
import useStyles from './styles'
import React, { useEffect } from 'react'
import { useSetorService } from 'hooks/useSetorService'
import { useUsuarioService } from 'hooks/useUsuarioService'
import { Autocomplete } from '@material-ui/lab'
import { useState } from 'react'
import { useCallback } from 'react'

export const FormEncaminhamentoComConfirmacao = (props) => {
  const { form, handleChange, multiple, operacao} = props
  const usuarioService = useUsuarioService()
  const setorService = useSetorService()
  const [processandoSetores, setProcessandoSetores] = useState(false)
  const [processandoUsuarios, setProcessandoUsuarios] = useState(false)
  const [usuarios, setUsuarios] = useState([])
  const [setores, setSetores] = useState([])
  const [setoresDestinoVestigio, setSetoresDestinoVestigio] = useState([])
  const classes = useStyles()

  const fetchUsuarios = useCallback(async () => {
    setProcessandoUsuarios(true)
    const response = await usuarioService.listarUsuarios()
    setUsuarios(response)
    setProcessandoUsuarios(false)
  }, [])

  useEffect(() => {
    fetchUsuarios()
  }, [fetchUsuarios])

  const fetchSetoresDestinoVestigio = useCallback(async () => {
    const response = await setorService.listarSetoresAsync(setProcessandoSetores)
    setSetoresDestinoVestigio(response)
  }, [])

  useEffect(() => {
    fetchSetoresDestinoVestigio()
  }, [fetchSetoresDestinoVestigio])

  useEffect(() => {
    const setoresUsario = form.usuarioDestino?.setores || []
    setSetores(setoresUsario)
    if (setoresUsario.length === 1) {
      const setor = setoresUsario[0]
      handleChange('setDest', setor)
    } else {
      handleChange('setDest', null)
    }
  }, [form.usuarioDestino])

  const situacoesVests = [
    { label: 'Vestígio para entrega ao destino final', slug: 'PARA_ENTREGA' },
    { label: 'Vestígio para armazenamento', slug: 'PARA_ARMAZENAMENTO' },
  ]

  return (
    <Grid container className={classes.container} spacing={3}>
      <Grid item md={12} sm={12} xs={12} lg={12}>
        <Typography className={classes.gridTitle}>
          <b>FORMULÁRIO DE {operacao.startsWith('ENTREGAR') ? 'ENTREGA' : 'ENCAMINHAMENTO'} DE VESTÍGIO</b>
        </Typography>
      </Grid>

      {processandoSetores || processandoUsuarios ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <>
          {!multiple && (
            <>
              <Grid item md={12} sm={12} xs={12} lg={12}>
                <TextField
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  label="NÚMERO DO LACRE"
                  name="lacre"
                  onChange={(e) => handleChange('lacre', e.target.value)}
                  value={form.lacre}
                />
              </Grid>
              <Grid item container md={12} sm={12} xs={12} className={classes.fieldGroup}>
                <Grid item md={12} sm={12} xs={12}>
                  <Typography variant="body2">TIPO DA EMBALAGEM</Typography>
                </Grid>
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup aria-label="tipo-embalagem" name="tipoEmbalagem" value={form.tipoEmbalagem || null} onChange={(e) => handleChange('tipoEmbalagem', e.target.value)} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <FormControlLabel value="SACO LACRE" control={<Radio />} label={<Typography variant="body2">SACO LACRE</Typography>} />
                    <FormControlLabel value="PLÁSTICO" control={<Radio />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
                    <FormControlLabel value="ENVELOPE PAPEL" control={<Radio />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
                    <FormControlLabel value="CAIXA" control={<Radio />} label={<Typography variant="body2">CAIXA</Typography>} />
                    <FormControlLabel value="AUSENTE" control={<Radio />} label={<Typography variant="body2">AUSENTE</Typography>} />
                    <FormControlLabel value="OUTRO" control={<Radio />} label={<Typography variant="body2">OUTRO</Typography>} />
                  </RadioGroup>
                </FormControl>
                {form.tipoEmbalagem === 'OUTRO' && (
                  <Grid item md={12} sm={12} xs={12}>
                    <TextField
                      label="OUTRO TIPO DE EMBALAGEM"
                      name="outroTipoEmbalagem"
                      variant="outlined"
                      value={form.outroTipoEmbalagem}
                      onChange={(e) => handleChange('outroTipoEmbalagem', e.target.value)}
                      disabled={form.tipoEmbalagem !== 'OUTRO'}
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                )}
              </Grid>
            </>
          )}
          <Grid item md={12} sm={12} xs={12}>
            <Autocomplete
              name="usuarioDestino"
              value={form.usuarioDestino}
              noOptionsText="Sem informações"
              options={usuarios}
              onChange={(event, newValue) => {
                handleChange('usuarioDestino', newValue)
              }}
              getOptionSelected={(option, value) => option.id === value || option === value}
              getOptionLabel={(option) => `${option.nome} ${option.cargo ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
              renderOption={(option) => `${option.nome} ${option.cargo ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="USUÁRIO DESTINO"
                  variant="outlined"
                  InputLabelProps={{
                      shrink: true,
                  }}
                  required
                />
              )}
            />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Autocomplete
              name="setDest"
              value={form.setDest}
              noOptionsText="Sem informações"
              options={setores}
              onChange={(event, newValue) => {
                handleChange('setDest', newValue)
              }}
              getOptionLabel={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
              renderOption={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="SETOR DESTINO"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                />
              )}
            />
          </Grid>

          {form?.setDest?.id === 184 && operacao === 'ENCAMINHAR_COM_CONFIRMACAO' && (
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <Autocomplete
                name="situacaoVest"
                value={situacoesVests.find((opt) => opt.slug === form.situacaoVest) || null}
                noOptionsText="Sem informações"
                options={situacoesVests}
                  onChange={(event, newValue) => {
                    handleChange('situacaoVest', newValue ? newValue.slug : null)
                }}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.slug === value?.slug}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label={'SITUAÇÃO DO VESTÍGIO'}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                )}
              />
            </Grid>
        )}

        {form?.setDest?.id === 184 && operacao === 'ENCAMINHAR_COM_CONFIRMACAO' && form?.situacaoVest == 'PARA_ENTREGA' && (
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <Autocomplete
                name="setEntregaVest"
                value={form.setEntregaVest}
                noOptionsText="Sem informações"
                options={setoresDestinoVestigio}
                onChange={(event, newValue) => {
                  handleChange('setEntregaVest', newValue)
                }}
                getOptionLabel={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
                renderOption={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.sigla.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label={'SETOR A SER ENTREGUE O VESTÍGIO'}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                )}
              />
            </Grid>
        )}

        <Grid item md={12} sm={12} xs={12}>
          <TextField
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
            label="OBSERVAÇÕES"
            name="observacao"
            onChange={(e) => handleChange('observacao', e.target.value)}
            value={form.observacao}
            multiline
          />
        </Grid>
        </>
      )}
    </Grid>
  )
}
